import { createBrowserRouter } from "react-router-dom";

import Layout from "./components/Layout";

// Auth / login & redirects
import Login from "./pages/login/login";
import RedirectJujumel from "./pages/login/redirectJujumel";
import RedirectBling from "./pages/login/redirectBling";
import RedirectPagbank from "./pages/login/redirectPagbank";
import RedirectTiny from "./pages/login/redirectTiny";
import RedirectTinyMooda from "./pages/login/redirectTinyMooda";
import RedirectTinyKr from "./pages/login/redirectTinyKr";
import RedirectTinyZaaper from "./pages/login/redirectTinyZaaper";
import RedirectTinyTeeFashion from "./pages/login/redirectTinyTeeFashion";

// Customers
import Customer from "./pages/customer/customer";
import CustomerList from "./pages/customer/customerList";
import ImportCustomer from "./pages/customer/importCustomer";

// Products & catalog
import Product from "./pages/product/product";
import ProductList from "./pages/product/productList";
import ImportProducts from "./pages/product/importProducts";
import ImportStock from "./pages/product/importStock";
import CategoryList from "./pages/categories/categoryList";
import ImportCategories from "./pages/categories/importCategory";
import Collection from "./pages/collection/collection";
import Highlights from "./pages/highlights/highlights";
import ColorsSizes from "./pages/config/color_sizes";
import Paleta from "./pages/config/paleta";

// Orders
import OrderList from "./pages/order/orderList";
import Itens from "./pages/order/itens";

// Campaign / marketing
import Campaign from "./pages/campaign/campaign";
import CampaignList from "./pages/campaign/campaignList";
import DiscountList from "./pages/discount/discountList";
import CashbackList from "./pages/cashback/cashbackList";
import Chatbot from "./pages/chatbot/chatbot";
import PushNotificationList from "./pages/push/PushNotificationList";
import ShowcasePage from "./pages/virtualOnTry/ShowcasePage";

// Reports & dashboards
import Home from "./pages/reports/home";
import HomeV2 from "./pages/reports/homeV2";
import IndicadoresVendas from "./pages/reports/indicadoresVendas";
import IndicadoresClientes from "./pages/reports/indicadoresClientes";
import IndicadoresProdutos from "./pages/reports/indicadoresProdutos";
import IndicadoresEstrategica from "./pages/reports/indicadoresEstrategica";
import IndicadoresPagamentos from "./pages/reports/indicadoresPagamentos";
import IndicadoresMapaVendas from "./pages/reports/indicadoresMapaVendas";
import RelatorioProdutos from "./pages/reports/relatorioProdutos";
import RelatorioProdutoVenda from "./pages/reports/relatorioProdutoVenda";
import RelatorioAvise from "./pages/reports/relatorioAvise";
import RelatorioEstoque from "./pages/reports/relatorioEstoque";
import RelatorioGradeIncompleta from "./pages/reports/relatorioGradeIncompleta";
import RelatorioPedidosClientes from "./pages/reports/relatorioPedidosClientes";
import CartListItem from "./pages/reports/cartListItem";
import CartList from "./pages/reports/cartList";
import LeadList from "./pages/reports/leadList";
import PaymentMoodaReport from "./pages/reports/paymentMoodaReport";
import AdsPerformance from "./pages/reports/midiaReport";
import DashCustomers from "./pages/dashboard/customer_dash";

// Admin / config
import Company from "./pages/company/company";
import User from "./pages/user/user";
import UserList from "./pages/user/userList";
import UserRep from "./pages/userRep/userRep";
import AccessControl from "./pages/access/accessControl";
import Invoice from "./pages/invoice/invoice";
import IntegrationError from "./pages/integration/integrationerrror";

// Tabs
import TabConfig from "./pages/tabs/TabConfig";
import TabDashboard from "./pages/tabs/TabDashboard";
import TabImport from "./pages/tabs/TabImport";

// Standalone redirect routes (outside the company layout)
const redirectRoutes = [
  { path: "/redirect", element: <RedirectBling /> },
  { path: "/redirectJujumel", element: <RedirectJujumel /> },
  { path: "/redirectPagBank", element: <RedirectPagbank /> },
  { path: "/redirectTiny", element: <RedirectTiny /> },
  { path: "/redirectTinyMooda", element: <RedirectTinyMooda /> },
  { path: "/redirectTinyKr", element: <RedirectTinyKr /> },
  { path: "/redirectTinyZaaper", element: <RedirectTinyZaaper /> },
  { path: "/redirectTinyTeeFashion", element: <RedirectTinyTeeFashion /> },
];

// Routes rendered inside the company Layout (sidebar + topbar)
const companyRoutes = [
  { path: "home", element: <Home /> },
  { path: "homev2", element: <HomeV2 /> },

  { path: "users", element: <UserList /> },
  { path: "users/:userId", element: <User /> },
  { path: "usersRep/:userRepId", element: <UserRep /> },

  { path: "customers", element: <CustomerList /> },
  { path: "customers/:customerId", element: <Customer /> },
  { path: "importcustomers", element: <ImportCustomer /> },

  { path: "products", element: <ProductList /> },
  { path: "products/:productId", element: <Product /> },
  { path: "importproducts", element: <ImportProducts /> },
  { path: "importstock", element: <ImportStock /> },
  { path: "categories", element: <CategoryList /> },
  { path: "importcategories", element: <ImportCategories /> },
  { path: "collection", element: <Collection /> },
  { path: "highlights", element: <Highlights /> },
  { path: "paleta", element: <Paleta /> },
  { path: "colorsize", element: <ColorsSizes /> },

  { path: "orders", element: <OrderList /> },
  { path: "orders/:orderId", element: <Itens /> },

  { path: "campaign", element: <CampaignList /> },
  { path: "campaign/:campaignId", element: <Campaign /> },
  { path: "discounts", element: <DiscountList /> },
  { path: "cashback", element: <CashbackList /> },
  { path: "chatbot", element: <Chatbot /> },
  { path: "push", element: <PushNotificationList /> },
  { path: "virtual/showcase", element: <ShowcasePage /> },

  { path: "indicadoresvendas", element: <IndicadoresVendas /> },
  { path: "indicadoresclientes", element: <IndicadoresClientes /> },
  { path: "indicadoresprodutos", element: <IndicadoresProdutos /> },
  { path: "indicadoresestrategica", element: <IndicadoresEstrategica /> },
  { path: "indicadorespagamentos", element: <IndicadoresPagamentos /> },
  { path: "indicadoresmapa", element: <IndicadoresMapaVendas /> },
  { path: "relatorio-produtos", element: <RelatorioProdutos /> },
  { path: "relatorio-produto-venda", element: <RelatorioProdutoVenda /> },
  { path: "relatorio-avise", element: <RelatorioAvise /> },
  { path: "relatorio-estoque", element: <RelatorioEstoque /> },
  { path: "relatorio-grade-incompleta", element: <RelatorioGradeIncompleta /> },
  { path: "relatorio-pedidos-clientes", element: <RelatorioPedidosClientes /> },
  { path: "carts", element: <CartListItem /> },
  { path: "cartlist", element: <CartList /> },
  { path: "leads", element: <LeadList /> },
  { path: "dashCustomers", element: <DashCustomers /> },
  { path: "paymentReport", element: <PaymentMoodaReport /> },
  { path: "adsPerformance", element: <AdsPerformance /> },

  { path: "company", element: <Company /> },
  { path: "invoice", element: <Invoice /> },
  { path: "acontrol", element: <AccessControl /> },
  { path: "integrationerror", element: <IntegrationError /> },

  { path: "tabimports", element: <TabImport /> },
  { path: "tabconfigs", element: <TabConfig /> },
  { path: "tabdashboard", element: <TabDashboard /> },
];

const router = createBrowserRouter([
  { path: "/:companyId/login", element: <Login /> },
  ...redirectRoutes,
  {
    path: "/:companyId",
    element: <Layout />,
    children: companyRoutes.map(({ path, element }) => ({
      path: `/:companyId/${path}`,
      element,
    })),
  },
]);

export default router;
